import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Head from "next/head";
import { useRouter } from "next/router";
export const withTitleSuffix = (title)=>title.includes("- cinch") ? title : `${title} - cinch`;
const CarFinanceHead = ({ title , fallbackTitle , description , fallbackDescription , canonicalUrl , robots , openGraph , twitterCard , generatedAt , HowTo  })=>{
    const router = useRouter();
    const ogData = openGraph === null || openGraph === void 0 ? void 0 : openGraph[0];
    const twitterCardData = twitterCard === null || twitterCard === void 0 ? void 0 : twitterCard[0];
    const pathname = (router === null || router === void 0 ? void 0 : router.asPath) ?? "";
    canonicalUrl = !canonicalUrl ? `https://www.cinch.co.uk${pathname.split("?")[0]}` : canonicalUrl;
    return /*#__PURE__*/ _jsxs(Head, {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: withTitleSuffix(title || fallbackTitle)
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: description || fallbackDescription
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "robots",
                content: (robots === null || robots === void 0 ? void 0 : robots.join(", ")) || "all"
            }, "robots"),
            generatedAt && /*#__PURE__*/ _jsx("meta", {
                name: "page_generated_at",
                content: `${generatedAt}`
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "icon",
                href: "/favicon-32x32-bfc05e34c2d7531ace62bdb1cc158dfe.png"
            }),
            ((ogData === null || ogData === void 0 ? void 0 : ogData.title) || (ogData === null || ogData === void 0 ? void 0 : ogData.type)) && /*#__PURE__*/ _jsx("meta", {
                property: "og:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.type) && /*#__PURE__*/ _jsx("meta", {
                property: "og:type",
                content: ogData.type
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.title) && /*#__PURE__*/ _jsx("meta", {
                property: "og:title",
                content: ogData.title
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.description) && /*#__PURE__*/ _jsx("meta", {
                property: "og:description",
                content: ogData.description
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageUrl) && /*#__PURE__*/ _jsx("meta", {
                property: "og:image",
                content: ogData.imageUrl
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageAlt) && /*#__PURE__*/ _jsx("meta", {
                property: "og:image:alt",
                content: ogData.imageAlt
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:card",
                content: twitterCardData.card
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:site",
                content: "@cinchuk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ _jsx("meta", {
                property: "twitter:domain",
                content: "cinch.co.uk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ _jsx("meta", {
                property: "twitter:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:title",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:description",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:image",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt) && /*#__PURE__*/ _jsx("meta", {
                name: "twitter:image:alt",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt
            }),
            process.env["STAGE_NAME"] === "production" && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "sitemap",
                        type: "application/xml",
                        href: "/sitemap.xml"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "manifest",
                        href: "/manifest.webmanifest",
                        crossOrigin: "anonymous"
                    })
                ]
            })
        ]
    });
};
export default CarFinanceHead;
